import 'Shared/global-header';
import 'Shared/header';
// header_languages.js is needed for the mobile language dropdown
import 'Shared/header_languages';
import 'Shared/newsletter';
import 'Shared/realtime_notifications';
import 'Shared/cart_drawer';
import 'Shared/iso_lang_header';
import 'Shared/device_navigator';
// Instant search for non-iFixit sites header
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import InstantSearchBar from 'Shared/Header/components/instant_search_bar';
import NanositeMobileSearch from 'Shared/Header/components/mobile_search/nanosite-mobile-search';

initializeChakraComponent('InstantSearchBar', InstantSearchBar, {
   'inputClassName':
      'h-[31px] py-0 w-[200px] bg-gray-100 text-gray-900 border border-gray-200 placeholder:text-gray-500',
});

initializeChakraComponent('InstantSearchMobile', NanositeMobileSearch, {
   'inputClassName':
      'h-[36px] py-0 w-full bg-gray-100 text-gray-900 border border-gray-200 placeholder:text-gray-500',
});
